import styled from "styled-components";

export const RegisterFormContainer = styled.div`
  &.dark {
    > ul li {
      background: #000;
      color: #eee;
      &.quickMenu ul li button {
        background: rgba(255, 255, 255, 0.1);
        color: #eee;
      }
      .info button {
        color: #eee;
      }
      .timeArea > div select,
      .info label .checkmark,
      input[type="text"],
      .file label {
        background: #333;
        color: #eee;
      }
      .info label .checkmark {
        border: 2px solid #333;
      }
      input:checked ~ .checkmark::after {
        border-color: rgba(62, 118, 238, 1);
      }
    }
  }
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  > ul {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  @media screen and (max-width: 767px) {
  }
`;

export const RegisterItemContainer = styled.li`
  width: calc(50% - 10px);
  background: rgba(255, 255, 255, 0.5);
  padding: 30px;
  border-radius: 30px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  justify-content: space-between;
  &.quickMenu {
    width: 100%;
    ul {
      li {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-bottom: 10px;
        img {
          width: 52px;
          height: 52px;
        }
        span {
          display: block;
          width: 140px;
          text-align: center;
        }
        div {
          width: 202px;
          cursor: pointer;
          gap: 10px;
          display: flex;
          align-items: center;
          overflow: hidden;
          height: 52px;
        }
        button {
          height: 52px;
          border: none;
          background: #fff;
          border-radius: 10px;
          color: rgba(0, 0, 0, 0.5);
          &:first-child {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 202px;
            gap: 10px;
            svg {
              margin: 0;
            }
          }
          &:last-child {
            width: 52px;
            svg {
              margin: auto;
            }
          }
          svg {
            display: block;
          }
        }
        input[type="text"] {
          width: calc(100% - 274px);
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .message {
    font-size: 14px;
    display: block;
    margin-bottom: 5px;
  }
  .file {
    width: 100%;
    display: flex;
    gap: 10px;
    input[type="file"] {
      display: none;
    }
    label {
      width: 160px;
      border: none;
      background: #fff;
      height: 52px;
      line-height: 52px;
      text-align: center;
      color: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
    .preview {
      width: 100px;
      height: 50px;
      max-width: calc(100% - 165px);
      /* height: 100%; */
      background: rgba(255, 255, 255, 0.5);
      border-radius: 10px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .info {
    font-weight: 700;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    label {
      width: auto;
      display: flex;
      gap: 5px;
      align-items: center;
      .checkmark {
        position: relative;
        width: 20px;
        height: 20px;
        background: #fff;
      }
    }
    button {
      background: transparent;
      border: none;
      font-weight: 700;
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 20px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.5);
    }
    .label {
      font-size: 20px;
      font-weight: 300;
    }
  }
  input[type="text"] {
    border: none;
    background: rgba(255, 255, 255, 0.5);
    width: 100%;
    height: 52px;
    padding: 0 20px;
    color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    &:focus {
      border: none !important;
      box-shadow: none;
    }
  }
  .timeArea {
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: 10px;
    > div {
      width: calc(50% - 5px);
      span {
        display: block;
        text-align: center;
        margin-bottom: 5px;
      }
      select {
        background-color: #fff;
        width: 100%;
        height: 52px;
        border-radius: 10px;
        text-align: center;
        border: none;
        &:focus {
          outline: none;
          border: none !important;
          box-shadow: none;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    font-size: 14px;
    height: auto;
    min-height: auto;
    max-height: 160px;
    gap: 20px;
    &.quickMenu {
      max-height: none;
      ul li {
        flex-wrap: wrap;
        div {
          width: 100%;
          img {
            width: 50px;
            height: 50px;
          }
          span {
            text-align: left;
            width: auto;
          }
        }
        input[type="text"] {
          width: calc(100% - 62px);
        }
        button {
          height: 30px;
        }
      }
    }
    .info {
      font-size: 20px;
      .label,
      button {
        font-size: 14px;
      }
    }
    .timeArea > div select,
    input[type="text"] {
      height: 30px;
    }
    .file {
      align-items: center;
      .preview {
        max-width: none;
        width: 100px;
        height: 50px;
        text-align: center;
      }
      label {
        width: 100px;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

export const RegisterIntroFormContainer = styled.div`
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  &.dark {
    .ck {
      color: #eee;
      background: #000;
    }
    .ck.ck-button:not(.ck-disabled):hover,
    a.ck.ck-button:not(.ck-disabled):hover,
    .ck.ck-button.ck-on,
    a.ck.ck-button.ck-on {
      background: rgba(255, 255, 255, 0.1);
    }
    .ck.ck-content,
    .ck.ck-button.ck-list-item-button,
    .ck.ck-button.ck-list-item-button.ck-on {
      background: #000;
    }
    .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content,
    .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused),
    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
  .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {
    box-shadow: none;
    border: 1px solid #ccc;
  }
`;

export const RegisterPortFormContainer = styled.div`
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  &.dark {
    .font_color_black {
      color: #eee;
    }
    .actions .buttons button:last-child {
      background: #000;
      color: #eee;
    }
  }
  .not {
    margin: 0 auto;
  }
  .actions {
    margin-top: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-wrap: wrap;
    .buttons {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      display: flex;
      gap: 20px;
      button {
        height: 40px;
        padding: 0 20px;
        border: none;
        &:first-child {
          background: rgba(37, 99, 235, 0.7);
          color: #fff;
        }
        &:last-child {
          background: rgba(255, 255, 255, 0.7);
        }
      }
    }
    .pagination {
      margin-top: 0;
    }
  }
  @media screen and (max-width: 1050px) {
    .actions .buttons {
      top: 150%;
      transform: translateY(50%);
      gap: 10px;
      button {
        height: 30px;
        border-radius: 5px;
        font-size: 12px;
      }
    }
  }
`;

export const RegisterNoticeFormContainer = styled.div`
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  &.dark {
    color: #eee;
    .actions .buttons button:last-child {
      background: #000;
      color: #eee;
    }
  }
  .actions {
    margin-top: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-wrap: wrap;
    .buttons {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      display: flex;
      gap: 20px;
      button {
        height: 40px;
        padding: 0 20px;
        border: none;
        &:first-child {
          background: rgba(37, 99, 235, 0.7);
          color: #fff;
        }
        &:last-child {
          background: rgba(255, 255, 255, 0.7);
        }
      }
    }
    .pagination {
      margin-top: 0;
    }
  }
  @media screen and (max-width: 1050px) {
    .actions {
      margin-top: 0px;
      .buttons {
        top: 150%;
        transform: translateY(50%);
        gap: 10px;
        button {
          height: 30px;
          border-radius: 5px;
          font-size: 12px;
        }
      }
    }
  }
`;

export const BoardSearchContainer = styled.div`
  &.dark {
    select,
    button,
    input[type="text"] {
      background: #eee;
      color: #000;
    }
  }
  .basic {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  select,
  button,
  input[type="text"] {
    background: rgba(255, 255, 255, 0.5);
    height: 55px;
    border: none;
    border-radius: 10px;
    color: rgba(0, 0, 0, 0.5);
    &:focus {
      outline: none;
      border: none !important;
      box-shadow: none;
    }
  }
  select {
    width: 230px;
    padding: 0 20px;
    cursor: pointer;
  }
  input[type="text"] {
    width: 310px;
    padding: 0 20px;
  }
  button {
    width: 55px;
  }
  @media screen and (max-width: 767px) {
    .basic {
      flex-wrap: wrap;
    }
    select,
    button,
    input[type="text"] {
      height: 30px;
      font-size: 14px;
    }
    select {
      width: 50%;
    }
    button {
      width: 20%;
    }
    input[type="text"] {
      width: calc(80% - 10px);
    }
  }
`;

export const RegisterPortViewFormContainer = styled.div`
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  &.dark {
    color: #eee;
    .font_color_gray {
      color: #eee;
    }
  }
  .actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    button {
      border: none;
      border-radius: 10px;
      padding: 10px 0;
      width: 100px;
      background: #555;
      &:last-child {
        margin-left: auto;
        background: rgba(37, 99, 235, 0.7);
        color: #fff;
      }
    }
  }
`;

export const RegisterNoticeWriteFormContainer = styled.div`
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  &.dark {
    color: #eee;
    .actions button:first-child {
      background: rgb(44, 45, 48);
      color: #eee;
    }
  }
  .actions {
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-top: 70px;
    button {
      width: 272px;
      height: 40px;
      border-radius: 5px;
      border: none;
      color: rgb(255, 255, 255);
      background: rgba(37, 99, 235, 0.7);
      font-size: 16px;
      &:first-child {
        color: #000;
        background: #fff;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    font-size: 14px;
  }
`;

export const RegisterPhotoUploadFormContainer = styled.div`
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  &.dark {
    .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable),
    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
    .cont input[type="text"] {
      border: 1px solid transparent !important;
      color: #eee;
      background: #000;
      &:focus {
        border: 1px solid rgba(255, 255, 255, 0.5) !important;
      }
    }
    .ck {
      color: #eee;
      background: #000;
    }
    .ck.ck-button:not(.ck-disabled):hover,
    a.ck.ck-button:not(.ck-disabled):hover,
    .ck.ck-button.ck-on,
    a.ck.ck-button.ck-on {
      background: rgba(255, 255, 255, 0.1);
    }
    .ck.ck-content,
    .ck.ck-button.ck-list-item-button,
    .ck.ck-button.ck-list-item-button.ck-on {
      background: #000;
      transition: 0.3s;
    }
    .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content,
    .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
  .cont {
    margin: 70px;
    input[type="text"] {
      margin-bottom: 30px;
      width: 100%;
      border: none;
      padding: 20px;
      border: 1px solid transparent !important;
      &:focus {
        border: 1px solid rgba(255, 255, 255, 0.5) !important;
        box-shadow: none;
      }
    }
  }
  .ck.ck-editor__editable {
    height: 500px;
  }
  .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
  .cont {
    margin: 0;
  }
  .actions {
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-top: 70px;
    button {
      width: 272px;
      height: 40px;
      border-radius: 5px;
      border: none;
      color: rgb(255, 255, 255);
      background: rgba(37, 99, 235, 0.7);
      font-size: 16px;
      &:first-child {
        color: #000;
        background: #fff;
      }
      &:last-child {
        background: #dedede;
        color: #000;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    font-size: 14px;
  }
`;

export const RegisterNoticeViewContainer = styled.div`
  &.dark {
    color: #eee;
    .font_color_black,
    .font_color_gray,
    .board_content p {
      color: #eee;
    }
  }
  margin: 0px auto 70px;
  max-width: 1440px;
  padding: 0px 20px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  letter-spacing: -1px;
  .content_control {
    display: flex;
    gap: 20px;
    -webkit-box-pack: center;
    justify-content: center;
    margin-top: 70px;
    button {
      width: 272px;
      height: 40px;
      border-radius: 5px;
      border: none;
      color: rgb(255, 255, 255);
      background: rgba(37, 99, 235, 0.7);
      font-size: 16px;
      margin: 0;
      &:first-child {
        color: rgb(0, 0, 0);
        background: rgb(255, 255, 255);
      }
      &:last-child {
        color: rgb(0, 0, 0);
        background: rgb(255, 255, 255);
      }
    }
  }
`;

export const BoardTableContainer = styled.table`
  margin: 50px 0;
  border-collapse: collapse;
  width: 100%;
  border-top: 1px solid #000;
  table-layout: fixed;
  &.dark {
    border-top: 1px solid #444;
    thead tr th,
    tbody tr td {
      border-bottom: 1px solid #444;
    }
  }
  &.white {
    border-top: 1px solid rgba(255, 255, 255, 0.5);
    thead tr th,
    tbody tr td {
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    }
  }
  caption {
    height: 0;
    font-size: 0;
    line-height: 0;
    overflow: hidden;
  }
  thead tr th,
  tbody tr td {
    height: 70px;
    text-align: center;
    border-bottom: 1px solid #000;
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 40%;
    }
    &:nth-child(4) {
      width: 10%;
    }
    &:nth-child(5) {
      width: 20%;
    }
    span {
      max-width: 100%;
      display: inline-block;
    }
  }
  thead tr th {
    font-size: 20px;
  }
  tbody tr td {
    font-size: 16px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media screen and (max-width: 1050px) {
    thead tr th {
      font-size: 16px;
    }
  }
  @media screen and (max-width: 767px) {
    &.dark {
      tbody tr {
        border-bottom: 1px solid rgb(68, 68, 68);
        td {
          border-bottom: none;
          border-top: none;
        }
      }
    }
    &.white {
      tbody tr td {
        border-bottom: none;
        border-top: none;
      }
    }
    margin: 30px 0;
    thead tr th {
      display: none;
    }
    tbody {
      tr {
        display: flex;
        flex-wrap: wrap;
        width: calc(100vw - 40px);
        border-bottom: 1px solid #000;
        padding: 10px;
        gap: 10px;
        td {
          border-bottom: none;
          height: auto;
          text-align: left;
          font-size: 12px;
          &.noticeSj {
            order: 1;
            width: 100%;
          }
          &.noticeCl {
            color: #0074ca;
            order: 2;
            position: relative;
            margin-right: 10px;
            &::after {
              content: "";
              position: absolute;
              display: block;
              width: 1px;
              height: 60%;
              background: rgba(0, 0, 0, 0.3);
              top: 50%;
              left: calc(100% + 10px);
              transform: translateY(-50%);
            }
          }
          &.createDt {
            order: 3;
          }
        }
      }
    }
  }
`;

export const BoardWriteContainer = styled.div`
  &.dark {
    ul li {
      input[type="text"],
      textarea,
      select {
        background: rgb(0, 0, 0);
        color: rgb(238, 238, 238);
        border: 1px solid rgb(0, 0, 0);
        &:focus {
          border: none !important;
        }
      }
    }
  }
  ul {
    li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .writing_tit {
        width: 150px;
      }
      .writing_cont {
        width: calc(100% - 150px);
      }
      input[type="text"],
      textarea,
      select {
        min-width: 160px;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 10px;
        background: transparent;
        padding: 0px 20px;
        resize: none;
        &:focus {
          outline: none;
          border: 1px solid rgba(255, 255, 255, 0.5) !important;
          box-shadow: none;
        }
      }
      input[type="text"] {
        height: 55px;
        line-height: 55px;
        width: 100%;
      }
      select {
        height: 55px;
        line-height: 55px;
      }
      textarea {
        padding: 20px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    ul li {
      flex-wrap: wrap;
      margin-bottom: 16px;
      .writing_tit {
        width: 100%;
        margin-bottom: 5px;
      }
      .writing_cont {
        width: 100%;
        input[type="text"],
        select {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
`;

export const ShortcutSelectorModal = styled.div`
  &.modal {
    width: 700px;
    height: 645px;
  }
  &.dark {
    color: #eee;
    ul li:hover {
      background: rgba(255, 255, 255, 0.15);
    }
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 20px;
    li {
      width: calc((100% - 40px) / 3);
      padding: 20px;
      border-radius: 20px;
      text-align: center;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
      img {
        width: 100px;
        height: 100px;
      }
      span {
        display: block;
        margin-top: 10px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    &.modal {
      width: 700px;
      max-width: 80vw;
      height: auto;
      max-height: 80vh;
    }
    .modalContent {
      padding: 15px;
    }
    ul {
      gap: 10px;
      li {
        width: calc((100% - 20px) / 3);
        padding: 10px;
        img {
          width: 50px;
          height: 50px;
        }
        span {
          font-size: 14px;
          text-align: center;
          white-space: pre-wrap;
        }
      }
    }
  }
`;
